import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutocomplete from '@/components/BaseAutocomplete.vue'
import { ref, reactive, computed, watch, PropType } from 'vue'
import { useFetchAddressSuggestions } from '@/queries/googleAddresses'
import { useFetchAddressDetails } from '@/queries/googleAddresses'
import { AddressSuggestionsPayload } from '@/models/location.model'
import { Option } from '@/models/shared.model'
import { v4 as uuidv4 } from 'uuid'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAddressSearch',
  props: {
  result: {
    type: String,
    default: undefined,
  },
  required: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Array as PropType<string[] | undefined>,
    default: () => [],
  },
  disabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  emits: ['optionClick'],
  setup(__props, { emit: emits }) {

const props = __props



const addressSearchString = ref('')
const compareString = ref('')
const googleAddressSearchResults = reactive<AddressSuggestionsPayload[]>([])
const minSearchStrLength = 3
const fetchAddressTimeoutId = ref()
const sessionToken = ref()
const { mutateAsync: fetchGoogleAddress } = useFetchAddressSuggestions(
  addressSearchString,
  sessionToken,
)
const isLoading = ref(false)

const getGoogleAddress = () => {
  isLoading.value = true
  !sessionToken.value && generateSessionToken()
  clearTimeout(fetchAddressTimeoutId.value)
  fetchAddressTimeoutId.value = setTimeout(() => {
    if (compareString.value === addressSearchString.value) return
    if (addressSearchString.value?.length < minSearchStrLength) return
    fetchGoogleAddress()
      .then((data) => {
        compareString.value = addressSearchString.value
        Object.assign(googleAddressSearchResults, data)
      })
      .finally(() => {
        isLoading.value = false
      })
  }, 500)
}

const generateSessionToken = () => (sessionToken.value = uuidv4())

const { mutateAsync: fetchAddressDetails } =
  useFetchAddressDetails(sessionToken)

const onAddressSelect = (value) => {
  if (value.key) {
    isLoading.value = true
    fetchAddressDetails(value.key)
      .then((data) => {
        sessionToken.value = null
        addressSearchString.value = value.label
        emits('optionClick', data)
      })
      .finally(() => {
        isLoading.value = false
      })
  }
}

const googleAddressOptions = computed<Option[]>(() => {
  return (googleAddressSearchResults || []).map(
    (item: AddressSuggestionsPayload) => {
      return {
        key: item.place_id,
        label: item.address,
      }
    },
  )
})
watch(
  () => props.result,
  (_newResult) => {
    if (_newResult) {
      addressSearchString.value = _newResult
    }
  },
)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutocomplete, {
    modelValue: addressSearchString.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((addressSearchString).value = $event)),
      _cache[2] || (_cache[2] = (value) => (addressSearchString.value = value))
    ],
    options: _unref(googleAddressOptions),
    required: props.required,
    "no-options-label": _ctx.$t('noResults'),
    label: _ctx.$t('Search for address'),
    "is-google-search": true,
    errors: __props.errors,
    "is-loading": isLoading.value,
    name: "googleAddress",
    "icon-left": "magnifying-glass",
    class: "address-search",
    disabled: __props.disabled,
    onKeyup: getGoogleAddress,
    onOptionClick: _cache[1] || (_cache[1] = (value) => onAddressSelect(value))
  }, null, 8, ["modelValue", "options", "required", "no-options-label", "label", "errors", "is-loading", "disabled"]))
}
}

})